import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';
import { colorsV2 } from '../colors-v2';

interface QuestionNumberProps extends React.HTMLAttributes<HTMLSpanElement> {
  state?: string | 'on' | 'off';
  type?: string | 'normal' | 'correct' | 'wrong' | 'missed' | 'answered';
  size?: string | 'mobile' | 'desktop';
  number: number | string;
  onClick?: () => void;
}

/**
 * This component follow the design in https://www.figma.com/file/DqRd7UQkNGcdvYL5fwZxlf/DOL-Design-Sytem-V2?node-id=453%3A405
 * All terms such as: `state`, `type`, `size` follow the design
 */
export const QuestionNumber = React.memo((props: QuestionNumberProps) => {
  const { state = 'off', type = 'normal', size = 'desktop', number, className, ...rest } = props;

  return (
    <Container className={cl(className, state, type, size)} {...rest}>
      {number}
    </Container>
  );
});

const Container = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  &.desktop {
    width: 24px;
    height: 24px;
    font-size: 12px;
    font-weight: 600;
  }

  &.mobile {
    width: 36px;
    height: 36px;
    font-size: 14px;
    font-weight: 500;
  }

  &.normal {
    &.off {
      background-color: ${colorsV2.gray20};
      color: ${colorsV2.black80};
    }

    &.on {
      background-color: ${colorsV2.gray20};
      color: ${colorsV2.black80};
    }
  }

  &.correct {
    &.off {
      background-color: ${colorsV2.green20};
      color: ${colorsV2.green100};
    }

    &.on {
      background-color: ${colorsV2.green100};
      color: ${colorsV2.white100};
    }
  }

  &.wrong {
    &.off {
      background-color: ${colorsV2.red20};
      color: ${colorsV2.red100};
    }

    &.on {
      background-color: ${colorsV2.red100};
      color: ${colorsV2.white100};
    }
  }

  &.missed {
    &.off {
      background-color: ${colorsV2.yellow20};
      color: ${colorsV2.yellow100};
    }

    &.on {
      background-color: ${colorsV2.yellow100};
      color: ${colorsV2.white100};
    }
  }

  &.answered {
    &.off {
      background-color: ${colorsV2.blue20};
      color: ${colorsV2.blue100};
    }

    &.on {
      background-color: ${colorsV2.blue100};
      color: ${colorsV2.white100};
    }
  }
`;
